import React, { FunctionComponent } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
const useStyle = makeStyles({
  iconButton: {
    minWidth: '0px',
    margin: '5px',
    color: '#4C5157',
    padding: '0',
    '& svg': {
      marginInlineEnd: '6px'
    },
    '& span': {
      fontSize: '12px',
      fontWeight: 700
    }
  }
});
const CustomIconButton = (props: {
  icon: JSX.Element;
  label: string;
  onClick: VoidFunction;
  tooltip?: string;
}) => {
  const classes = useStyle();
  return (
    <Button
      onClick={props.onClick}
      aria-hidden
      className={classes.iconButton}
      title={props.tooltip}
    >
      <>
        {props.icon}
        <span>{props.label}</span>
      </>
    </Button>
  );
};
export default CustomIconButton;
